import React, {Component} from 'react';
import cn from "classnames"
import {connect} from 'react-redux'
import injectSheet, {withTheme} from 'react-jss'
import {getGlobalContent} from "../selectors"
import {UnstyledLink} from "./Widgets/Link"

import SVGSymbol from "./SVGSymbol"
import {getMenuIsOpen} from '../selectors'
import Transition from 'react-transition-group/Transition';
import {TweenLite} from "gsap"
import {getScrollBarWidth} from '../utils/measure'
import SocialLinks from './Widgets/SocialLinks'
import addImage from '../img/icons/add.svg'
import {getCurrentLocation, getSelectedGender, getSelectedGenderLabel} from "../selectors/content";
import {genderItems, genderEmpty} from "../utils/gender"
import {selectGender, CONTENT_ROUTE} from "../actions"

const duration = 600;

class Menu extends Component {

    constructor(props) {
        super(props);
        this.state = {filterOpen: false, searchQuery: ''};
    }

    _onEntering = (node) => {
        const {theme} = this.props;
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.marginRight = getScrollBarWidth() + 'px';
        node.style.overflow = 'hidden';
        const height = document.documentElement.clientHeight - theme.header.height('height').height;
        TweenLite.to(node, 0.35, {height: height, onComplete: () => {
            node.style.overflow = 'auto';
        }});
    }

    _onEntered = (node) => {
        node.style.overflow = 'auto';
    }

    _onExiting = (node) => {
        node.style.overflow = 'hidden';
        TweenLite.to(node, 0.35, {height: 0, onComplete: () => {
            document.documentElement.style.overflow = 'auto';
            document.documentElement.style.marginRight = 'auto';
        }});
    }

    _toggleFilterOpenState = () => {
        this.setState({filterOpen: !this.state.filterOpen})
    }

    _selectGander = (gender) => {
        const {location, handleGenderChanged} = this.props;
        this.setState({filterOpen: false})
        handleGenderChanged(gender, location);
    }

    _handleSearch = (event) => {
        const {handleSearch} = this.props;
        handleSearch( this.state.searchQuery );
        event.preventDefault();
    }

    _searchQueryChanged = (event) => {
        this.setState({searchQuery: event.target.value});
    }

    render() {
        const {classes, global, show, gender, genderLabel} = this.props;
        const {filterOpen, searchQuery} = this.state;
        if(!global) return null;

        return (
            <Transition in={show} timeout={duration} onEntering={this._onEntering} onEntered={this._onEntered} onExiting={this._onExiting} unmountOnExit={true} appear={true}>
                {(state) => (
                    <div className={cn(classes.container, {show})}>
                        <nav className={classes.mainNavContainer}>
                            <ul className={classes.mainNav}>
                                {global.search &&
                                <li className={cn(classes.mainNavItem, classes.searchNavItem)}>
                                    <form onSubmit={this._handleSearch}>
                                        <input className={classes.searchInput} type="search"
                                               placeholder={global.search.search_input_placeholder}
                                               value={searchQuery}
                                               onChange={this._searchQueryChanged}/>
                                    </form>
                                </li>
                                }
                                <li className={classes.divider}></li>
                                <li className={classes.mainNavItem}>
                                    <a onClick={this._toggleFilterOpenState}>{genderLabel}<SVGSymbol icon={addImage} className={cn(classes.addIcon, { open: filterOpen })}></SVGSymbol></a>
                                    <ul className={cn(classes.subNav, {open: filterOpen})}>
                                        <li className={cn(classes.mainNavItem, classes.filterNavItemTitle)}>Set Edition preference:</li>
                                        {genderItems.map((item, i) => (<li key={item} className={cn(classes.mainNavItem)}>
                                            <a className={cn(classes.filterNavItem, {selected: gender === item})} onClick={() => this._selectGander(item)}>{item}</a>
                                        </li>))}
                                    </ul>
                                </li>
                                <li className={classes.divider}></li>
                                {global.menu && global.menu.map(menu => {
                                    return <li className={classes.mainNavItem} key={menu.url}><UnstyledLink link={{url: menu.url, label: menu.title}}></UnstyledLink></li>
                                })}
                            </ul>
                        </nav>
                        <footer className={classes.footer}>
                            <SocialLinks global={global} className={classes.socialLinks} iconClassName={classes.socialLink} />
                        </footer>
                    </div>
                )}
            </Transition>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        global: getGlobalContent(state),
        show: getMenuIsOpen(state),
        location: getCurrentLocation(state),
        gender: getSelectedGender(state),
        genderLabel: getSelectedGenderLabel(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleGenderChanged: (gender, location) => {
            dispatch(selectGender(gender));
            dispatch( { type: CONTENT_ROUTE, payload: [ location.pathname ], query: { g: gender !== genderEmpty ? gender : undefined} } );
        },
        handleSearch: ( query ) => {
            //dispatch(searchQueryChanged(query, false)),
            dispatch( { type: CONTENT_ROUTE, payload: [ '/search' ], query: { q: query} } );
        },
    }
}


export default withTheme(connect(mapStateToProps, mapDispatchToProps)( injectSheet( (theme) => ({
    container: {
        position: "fixed",
        '-webkit-transform': 'translateZ(0)',
        left: 0,
        height: 0,
        width: '100%',
        overflow: "auto",
        backgroundColor: theme.colors.white,
        ...theme.header.height('top'),
        display: 'flex',
        flexDirection: 'column',
        zIndex: theme.zIndex.menu
    },
    mainNavContainer: {
        flexGrow: 1,
    },
    footer: {
        flexGrow: 0,
        backgroundColor: theme.colors.info,
        padding: theme.spacing.normal
    },
    mainNav: {
        margin: theme.spacing.small,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    subNav: {
        overflow: 'hidden',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        height: 0,
        transition: 'height 0.2s ease-in-out',
        '&.open': {
            height: 200
        }
    },
    mainNavItem: {
        textAlign: 'center',
        margin: `10px 0`,
        '&.hide': {
            display: 'none'
        },
        "& a": {
            color: theme.colors.black,
            textTransform: 'uppercase',
            ...theme.font.menu.mobile,
            textDecoration: "none"
        },
        [theme.breakpoint("laptop")]: {
            margin: `10px ${theme.spacing.small}`,
        }
    },
    filterNavItemTitle: {
        width: 200,
        textAlign: 'left',
    },
    filterNavItem: {
        width: 200,
        textAlign: 'left',
        position: 'relative',
        display: 'block',
        paddingLeft: 27,
        "&:after": {
            content: '""',
            position: 'absolute',
            top: 'calc(50% - 7px)',
            left: 0,
            width: 14,
            height: 14,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'rgba(0, 0, 0, 0.3)',
            borderRadius: '50%',
        },
        '&.selected:after': {
            backgroundColor: theme.colors.primary
        }
    },
    searchNavItem: {
        width: '100%'
    },
    searchInput: {
        "&[type=search]": {
            '-webkit-appearance': 'none',
        },
        ...theme.font.title.h3,
        outline: 'none',
        width: '100%',
        fontStyle: 'normal',
        textTransform: "none",
        textAlign: 'center',
        border: 'none',
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        boxShadow: 'none'
    },
    divider: {
        margin: theme.spacing.tiny,
        backgroundColor: theme.colors.divider,
        height: 1,
        width: '100%',
        opacity: 0.5
    },
    searchIcon: {
        marginRight: 5,
        height: 12,
    },
    addIcon: {
        width: 12,
        height: 12,
        marginLeft: 5,
        '&.open': {
            transform: 'rotate(45deg)'
        }
    },
    socialLinks: {
        justifyContent: 'center'
    },
    socialLink: {
        color: theme.colors.black
    }
}))(Menu)));



// WEBPACK FOOTER //
// ./src/components/Menu.js